import React, { useState, useEffect, useRef } from "react";

export default function VideoWithZoom({ src = "" }) {
  const [open, setOpen] = useState(false);
  const [validSrc, setValidSrc] = useState("");
  const [loading, setLoading] = useState(true);
  const videoRef = useRef(null);

  // CLEAN URL (same as ImageWithZoom)
  useEffect(() => {
    if (!src) {
      setValidSrc("");
      setLoading(false);
      return;
    }

    let fixed = src.trim();
    fixed = fixed.replace(/^"|"$/g, "");
    fixed = fixed.replace(/&amp;/g, "&");

    // remove markdown wrappers if any
    if (fixed.startsWith("![")) {
      fixed = fixed.replace(/!\[.*?\]\(/, "").replace(/\)$/, "");
    }

    setValidSrc(fixed);
    setLoading(true);
  }, [src]);

  // Prevent scrolling when zoomed
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  const handleLoaded = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
  };

  // Backend proxy download (CORS-safe)
  const handleDownload = () => {
    if (!validSrc) return;

    const downloadUrl = `${
      process.env.REACT_APP_API_URL
    }/chat/download-video?url=${encodeURIComponent(validSrc)}`;

    const a = document.createElement("a");
    a.href = downloadUrl;
    a.click();
  };

  return (
    <>
      {/* Thumbnail Player */}
      <div style={{ position: "relative", marginTop: 10 }}>
        {loading && (
          <div
            style={{
              width: 240,
              height: 140,
              borderRadius: 10,
              background: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              color: "#666",
              border: "1px solid #ddd",
            }}
          >
            Generating video…
          </div>
        )}

        {validSrc && (
          <video
            ref={videoRef}
            src={validSrc}
            controls
            preload="metadata"
            onLoadedMetadata={handleLoaded}
            onError={handleError}
            style={{
              width: "100%",
              maxWidth: 360,
              borderRadius: 8,
              cursor: "zoom-in",
              display: loading ? "none" : "block",
            }}
            onClick={() => setOpen(true)}
          />
        )}
      </div>

      {/* ZOOM MODAL */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.75)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(4px)",
          }}
        >
          <video
            src={validSrc}
            controls
            autoPlay
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: 10,
              boxShadow: "0 4px 25px rgba(0,0,0,0.4)",
            }}
            onClick={(e) => e.stopPropagation()}
          />

          {/* CLOSE */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
            style={{
              position: "absolute",
              top: 20,
              right: 25,
              width: 38,
              height: 38,
              borderRadius: "50%",
              border: "1px solid #ccc",
              background: "white",
              fontSize: 22,
              cursor: "pointer",
            }}
          >
            ✕
          </button>

          {/* DOWNLOAD */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDownload();
            }}
            style={{
              position: "absolute",
              bottom: 25,
              right: 40,
              padding: "10px 16px",
              background: "white",
              border: "1px solid #ccc",
              borderRadius: 8,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            ⬇ Download
          </button>
        </div>
      )}
    </>
  );
}
